import { useEffect } from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state) => ({
  isSwitcherOpen: state.switcher.isSwitcherOpen,
});

const ThemeWatcher = (props) => {
  const setWhiteTheme = () => {
    document.documentElement.classList.remove('dark-theme');
  };

  const setDarkTheme = () => {
    document.documentElement.classList.add('dark-theme');
  };

  useEffect(() => {
    if (props.isSwitcherOpen) {
      setDarkTheme();
    } else {
      setWhiteTheme();
    }
  }, [props.isSwitcherOpen]);

  return null;
};

export default connect(mapStateToProps)(ThemeWatcher);
